import { Fragment, useCallback, useContext, useState } from "react";
import { Grid } from "@mui/material";
import { ParagraphText, UBButton, UBInput } from "../../../../Libraries";
import {
    PkrIcon,
} from "../../../../assets/icons/icon";
import "./../variantAStyle.css";
import { Box } from "@mui/material";
import styles from "./../styles.module.css";
import { HeaderRupin } from "../../../common";
import FooterRupin from "../../../common/FooterRupin";
import { LanguageContext } from "../../../../context/LanguageContext";
import { analytics, triggerLogEvent } from "../../../../config/firebase";
import { handleApi } from "../../../../apis";
import { useLocation, useNavigate } from "react-router-dom";
import { POST_CAPTCHA, PUT_CAPTCHA } from "../../../../apis/configuration";
import Recapcha from "./Recaptcha";
import BusinessLoader from "../../../common/BusinessLoader";
import VerifyOTP from "./VerifyOtp";
import { useSnackbar } from "../../../../context/SnackbarContext";
import CreatePin from "./CreatePin";

const ForgotPin = () => {
    const location = useLocation();
    const [otpScreen, setIsOtpScreen] = useState({ phone: "", OTPresponse: {} });
    const [isCreateNewPin, setIsCreateNewPin] = useState(false);
    const [loading, setLoading] = useState(false);
    const [phone, setPhone] = useState(location?.state?.phone || "");
    const [reCaptcha, setReCaptcha] = useState("");
    const [error, setError] = useState(false);
    const [captchaDoc, seCaptchaDoc] = useState("");
    const [isResetReCaptcha, setIsResetReCaptcha] = useState(false);
    const [I18n] = useContext(LanguageContext);
    const navigate = useNavigate();
    const { showSnackbar } = useSnackbar();

    const handleCancel = () => {
        setIsOtpScreen({ phone: "", OTPresponse: {} });
        setIsCreateNewPin(false);
        setReCaptcha("");
        setError("");
        seCaptchaDoc("");
    }


    const handleSubmit = async (e) => {
        try {
            e?.preventDefault();
            if (loading || !(phone.length > 10 && reCaptcha)) return;
            setLoading(true);
            const response = await handleApi(POST_CAPTCHA, { payment_process: "pin_reset", phone_number: phone, pin_reset_captcha: true }, null, navigate);
            if (response?.document_id && response?.captcha) {
                seCaptchaDoc(response?.document_id)
                const payload = {
                    "payment_process": "pin_reset",
                    phone_number: phone,
                    document_id: response?.document_id,
                    "g-recaptcha-response": reCaptcha,
                    web:true
                }
                const responsePUT = await handleApi(PUT_CAPTCHA, payload, null, navigate);
                setLoading(false);
                if (responsePUT?.otp_sent) {
                    setIsOtpScreen({
                        phone: phone,
                        OTPresponse: responsePUT,
                    });
                }
            }
        } catch (error) {
            showSnackbar({
                message: error.response.data.message || "Error in Send code",
                severity: "error",
                icon: "",
                toastId: "sendCodeError",
            });
            setIsResetReCaptcha(true);
            setTimeout(() => setIsResetReCaptcha(false), 1000)
            setLoading(false);
        }
    };

    const handlePhoneNumberChange = useCallback(
        (value) => {
            if (phone.length == 0 && value.length >= 1)
                triggerLogEvent(analytics, "number_entered_forgot_pin_screen");

            let patt = /03[0-9]{2}(?!1234567)(?!1111111)(?!7654321)[0-9]{7}/; // VALIDATION FOR PAKISTANI MOBILE NUMBER
            if (value.match(patt) === null && value.length === 11) {
                setError(I18n.phone_number_format);
                return;
            }
            setError("");
            setPhone(value);
        },
        [phone.length, I18n.phone_number_format],

    );

    const handleRecaptcha = async (captcha) => {
        setReCaptcha(captcha);
    }


    return (
        <Box className="signUpWrapper">
            {isCreateNewPin ?
                <CreatePin
                    handleCancel={handleCancel}
                    handleSetPINSuccess={() => {
                        navigate("/", {
                            replace: true,
                            state: { phoneNumber: phone },
                        });
                    }}
                    documentId={captchaDoc}
                    phone={phone}
                /> :
                otpScreen?.OTPresponse?.otp_sent ?
                    <VerifyOTP
                        handleVerifyOTP={(e) => setIsCreateNewPin(Boolean(e?.verified))}
                        phone={phone}
                        sendOTPResponse={otpScreen?.OTPresponse}
                        documentId={captchaDoc}
                        reCaptcha={reCaptcha}
                        setDocumentId={seCaptchaDoc}
                    /> :
                    <Fragment>
                        <BusinessLoader loadBusiness={loading} />
                        <Grid container className={`${styles.signUpScreenWrapper} onBoardingScreenWrapper`}>
                            <Grid item md={12} className={`${styles.signUpScreenGrid} ${styles.forgotPinScroll}`}>
                                <HeaderRupin />
                                <Box className={styles.signUpFieldWrapper}>
                                    <Box className={styles.SignUpInnerBox}>
                                        <ParagraphText className={"fontSize24 fontWeight500"}>{I18n.enter_phone_number}</ParagraphText>
                                        <form className={styles.signUpForm} onSubmit={handleSubmit}>
                                            <UBInput
                                                inputId="forgot_pin_phone_input"
                                                prefix={<span className={styles.PkrStyle}><PkrIcon />+92<span className={"newBorderColor marginLeft10"}>|</span></span>}
                                                label={I18n.phone_number}
                                                placeholder={"03xxxxxxxxx"}
                                                error={{ text: error, show: !!error }}
                                                maxLength={11}
                                                onlyNumbers={true}
                                                isLeadingZero={false}
                                                value={phone}
                                                autoFocus={true}
                                                onChange={(e, value) => handlePhoneNumberChange(value)}
                                            />
                                            <Recapcha setReCaptcha={handleRecaptcha} isResetReCaptcha={isResetReCaptcha}/>
                                        </form>
                                        <UBButton
                                            id="forgot_pin_send_otp_btn"
                                            title={I18n.send_code}
                                            loading={loading}
                                            
                                            className={`ubPrimaryButton textUppercase ${styles.signUpButton}`}
                                            disabled={loading || !(phone.length > 10 && reCaptcha)}
                                            onClick={handleSubmit}
                                        />
                                    </Box>
                                </Box>
                                <FooterRupin />
                            </Grid>
                        </Grid>
                    </Fragment>}
        </Box>
    );
}

export default ForgotPin;